<div class="w-full flex flex-col justify-start items-start">
  <div class="flex flex-row justify-start items-center w-full gap-x-2">
    <h3>Delivery Estimate</h3>
    <mat-icon [matTooltip]="helpText" class="text-gray-300">help</mat-icon>
  </div>

  @if (noPlaceSelected$ | async) {
  <p>
    Please use the address search to select location and view estimates for
    delivery.
  </p>
  } @else {
  @if (estimateError$ | async; as estimateError) {
  <p>{{ estimateError }}</p>
  } @else {
  <p *ngIf="distanceAndDuration$ | async as distanceDuration">
    {{ distanceDuration.distance.toFixed(1) }} Km /
    {{ distanceDuration.duration.toFixed(1) }} minutes
  </p>
  <div class="flex flex-row justify-start items-center w-full">
    <ngx-skeleton-loader *ngIf="loading | async; else showEstimates" appearance="line" count="3"></ngx-skeleton-loader>
    <ng-template #showEstimates>
      <ng-container *ngIf="estimate$ | async as estimates">
        <ng-container *ngIf="estimates.length; else unableToCalculate">
          <div
            class="w-full md:gap-x-4 gap-y-2 md:gap-y-0 grid md:grid-cols-3 md:grid-rows-1 grid-rows-3 grid-cols-1 py-2 w-full">
            <div
              class="w-full border bg-blue-50 rounded border-blue-400 text-blue-900 flex flex-col items-stretch justify-center cursor-pointer"
              (click)="estimateSelected.emit(estimate.value)" *ngFor="let estimate of estimates">
              <p class="w-full text-center p-0 m-0">
                {{ estimate.label }}
              </p>
              <p class="w-full text-center font-bold p-0 m-0">
                {{ estimate.value | hlCurrency | async }}
              </p>
            </div>
          </div>
        </ng-container>
        <ng-template #unableToCalculate>
          <p>Unable to calculate delivery estimates for this location.</p>
        </ng-template>
      </ng-container>
    </ng-template>
  </div>
  }
  }
</div>